import $ from 'jquery';

import { SelectBox } from '../select';

const { regionSlug } = window.ebayAds;

class regionSelector {
	_selectorCtn;
	_button;
	_modal;
	_close;
	_selectBox;

	constructor( selectorCtn ) {
		this.selectorCtn = $( selectorCtn );

		if ( this.selectorCtn.length ) {
			this.salt = this.selectorCtn.attr( 'data-salt' );
			this.button = this.selectorCtn.find( '.region-selector__button' );
			this.modal = this.selectorCtn.find( '.region-selector__modal' );
			this.close = this.selectorCtn.find( '.region-selector__modal .close-modal' );

			if ( this.button.length && this.modal.length && this.close.length ) {

				const selectBoxEl = this.modal.find('.select-box');
				this.selectBox = new SelectBox( selectBoxEl );

				this.bindEvents();
			}
		}
	}

	bindEvents() {
		this.modalClick();
		this.buttonClick();
		this.closeClick();
		this.selectedRegion();
	}

	modalClick() {
		this.modal.find('.region-selector__modal-content').on( 'click', ( e ) => {
			e.preventDefault();
			e.stopPropagation(); // Stop propagation that closes the modal.
		} );
	}

	buttonClick() {
		this.button.on( 'click', ( e ) => {
			e.preventDefault();
			e.stopPropagation(); // Stop propagation that closes the modal.

			const action = this.modal.hasClass( 'hide-modal' );
			this.openModal( action );
		} );
	}

	closeClick() {
		this.close.on( 'click', () => {
			this.openModal( false );
		} );
	}

	openModal( open = true ) {

		open ? this.modal.addClass( 'show-modal' ) : this.modal.removeClass( 'show-modal' );
		open ? this.modal.removeClass( 'hide-modal' ) : this.modal.addClass( 'hide-modal' );

		// Add or remove the click event to close the modal from clicking outside.
		if ( open ) {
			$( document ).on( `click.modal-${this.salt}`, (e) => {
				this.openModal( false );
			} );
		} else {
			$( document ).off(  `click.modal-${this.salt}` );
		}
	}

	selectedRegion() {
		this.selectBox.selectBoxElCtnEl.on( 'selectedValue', ( e ) => {

			this.openModal( false );

			if ( e.inputData && e.inputData.url ) {
				window.location.href = e.inputData.url;
			} else {
				window.location.href = this.buildURL( window.location.href, e.value );
			}

		} );
	}

	buildURL( url, value ) {
		url = new URL( url );
		let params = url.searchParams;

		params.set( 'geoip', '' );
		params.set( 'country', value );

		return url.toString();
	}

	getCookie(name) {
		return (name = (document.cookie + ';').match(new RegExp(name + '=.*;'))) && name[0].split(/=|;/)[1];
	}

	setCookie(name, value, days) {
		var e = new Date;
		e.setDate( e.getDate() + days );
		document.cookie = name + "=" + value + ';expires=' + e.toUTCString() + ';path=/;domain=.' + document.domain;
	}

	set selectorCtn( value ) {
		this._selectorCtn = value;
	}

	set button( value ) {
		this._button = value;
	}

	set modal( value ) {
		this._modal = value;
	}

	set selectBox( value ) {
		this._selectBox = value;
	}

	set close( value ) {
		this._close = value;
	}

	set salt( value ) {
		this._salt = value;
	}

	get selectorCtn() {
		return this._selectorCtn;
	}

	get button() {
		return this._button;
	}

	get modal() {
		return this._modal;
	}

	get selectBox() {
		return this._selectBox;
	}

	get close() {
		return this._close;
	}

	get salt() {
		return this._salt;
	}
}

class regionSelectors {
	_selectorCtns;

	constructor() {
		this.selectorCtns = $( '.region-selector[data-salt]' );

		if ( this.selectorCtns.length ) {
			this.selectorCtns.each( ( index, element ) => {
				new regionSelector( element );
			} );
		}
	}

	set selectorCtns( value ) {
		this._selectorCtns = value;
	}

	get selectorCtns() {
		return this._selectorCtns;
	}
}

// eslint-disable-next-line no-shadow
( function( $ ) {
	'use strict';
	$( document ).ready( function() {
		new regionSelectors();
	} );
// eslint-disable-next-line no-undef
}( jQuery ) );
